/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/game';
import { SECRET } from '@/store/types';

export interface StoreGameDailyState {
  game: string;
  daily: boolean[];
}

export default {
  namespaced: true,
  state: {
    game: null,
    daily: [],
  },
  getters: {},
  actions: {
    [SECRET.GET_DAILY]({ commit, state }, { game }) {
      if (game !== state.game && state.daily.length === 0) {
        return new Promise((resolve, reject) => {
          api.getDaily(game).then((res) => {
            commit(SECRET.GET_DAILY, { game, data: res.data });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [SECRET.GET_DAILY](state, { game, daily }) {
      state.game = game;
      state.daily = daily;
    },
  },
};
